import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ed } from '../../lib/editTexts';

/**
 * Google-Maps-Karte erst nach ausdruecklichem Klick laden (Zwei-Klick-Loesung):
 * vorher geht keine Verbindung zu Google, siehe Datenschutzerklaerung „Google Maps“.
 */
export default function MapConsent({ embedUrl, mapsUrl, height = 280 }) {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);

  if (loaded && embedUrl) {
    return (
      <iframe title={t('map.title')} src={embedUrl} width="100%" height="100%"
        style={{ border: 0, display: 'block', minHeight: height }} allowFullScreen loading="lazy"
        referrerPolicy="no-referrer-when-downgrade" />
    );
  }
  return (
    <div style={{ minHeight: height, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 12, padding: 20, textAlign: 'center', color: '#5e554b', fontSize: 14, lineHeight: 1.5 }}>
      <div style={{ maxWidth: 320 }} {...ed('map.consent')}>
        {t('map.consent')}
      </div>
      <button type="button" onClick={() => setLoaded(true)} disabled={!embedUrl} className="kac-btn-ghost"
        style={{ cursor: embedUrl ? 'pointer' : 'default', font: 'inherit', fontWeight: 600 }} {...ed('map.load')}>
        {t('map.load')}
      </button>
      {mapsUrl && mapsUrl !== '#' && (
        <a href={mapsUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#C0291F', fontWeight: 600, textDecoration: 'none' }}>
          <span {...ed('map.open')}>{t('map.open')}</span> →
        </a>
      )}
    </div>
  );
}
